import React, { useContext } from "react";
import { Stepper } from "@yoast/ui-library";
import ConnectSite from "./ConnectSite";
import Downloading from "./Downloading";
import ProcessingOrder from "./ProcessingOrder";
import { InstallContext, InstallContextProvider, Steps } from "./InstallContext";
import * as styles from "./InstallStyles.scss";
import classNames from "classnames";
import LogoImage from "../../icons/Yoast-logo.svg";
import { defineMessages, FormattedMessage } from "react-intl";
import LinkGoogleAccounts from "./LinkGoogleAccounts";
import { FinishStep } from "./FinishStep";


const messages = defineMessages( {
	checkout: {
		id: "install.checkout",
		defaultMessage: "Checkout",
	},
	stepProcessingOrder: {
		id: "install.step.processingOrder",
		defaultMessage: "Complete order",
	},
	stepLinkGoogleAccount: {
		id: "install.step.linkGoogleAccount",
		defaultMessage: "Link Google account(s)",
	},
	stepConnectSite: {
		id: "install.step.connectSite",
		defaultMessage: "Connect your site",
	},
	stepDownload: {
		id: "install.step.download",
		defaultMessage: "Install Premium",
	},
	stepFinish: {
		id: "install.step.finish",
		defaultMessage: "Finish installation",
	},
} );

const messageByStep = {
	[ Steps.PROCESSING_ORDER.id ]: messages.stepProcessingOrder,
	[ Steps.INSTALL_DOCS_ADDON.id ]: messages.stepLinkGoogleAccount,
	[ Steps.CONNECT_SITE.id ]: messages.stepConnectSite,
	[ Steps.DOWNLOAD.id ]: messages.stepDownload,
	[ Steps.FINISH.id ]: messages.stepFinish,
};

const componentByStep = {
	[ Steps.PROCESSING_ORDER.id ]: ProcessingOrder,
	[ Steps.INSTALL_DOCS_ADDON.id ]: LinkGoogleAccounts,
	[ Steps.CONNECT_SITE.id ]: ConnectSite,
	[ Steps.DOWNLOAD.id ]: Downloading,
	[ Steps.FINISH.id ]: FinishStep,
};

/**
 * Checks which component should be rendered.
 *
 * @returns {React.JSX.Element} the in react context wrapped InstallContainer or Downloading component.
 */
const InstallationFlow = () => {
	/**
	 * @returns {object} the active component.
	 */
	const ActiveComponent = () => {
		const { steps } = useContext( InstallContext );
		const StepComponent = componentByStep[ steps.current.id ];

		return <div>
			<div className={ styles.header }>
				<div className={ classNames( styles.headerContainer, styles.wideContent ) }>
					<div className={ styles.headerLogo }>
						<img src={ LogoImage } alt="Yoast SEO for everyone" />
						<p>
							<FormattedMessage { ...messages.checkout } />
						</p>
					</div>
				</div>
			</div>
			<div className={ classNames( styles.wideContent ) }>
				<Stepper currentStep={ steps.currentIndex } className={ styles.stepper }>
					{ steps.available.map( ( availableStep ) => {
						const isCurrentStep = availableStep === steps.current;
						const stepIsBeforeCurrent = availableStep.position < steps.current.position;
						return <Stepper.Step
							key={ availableStep.id.toString() }
							isActive={ isCurrentStep }
							isComplete={ stepIsBeforeCurrent || ( isCurrentStep && availableStep.markAsCompleteImmediately ) }
						>
							<div className={ styles.label }>
								<FormattedMessage { ...messageByStep[ availableStep.id ] } />
							</div>
						</Stepper.Step>;
					} ) }
				</Stepper>
			</div>
			<div className={ classNames( styles.stepContent ) }>
				<StepComponent />
			</div>
		</div>;
	};

	return (
		<InstallContextProvider>
			<ActiveComponent />
		</InstallContextProvider>
	);
};

export default InstallationFlow;
